import axios from 'axios';
import store, { history } from '../store';
import addError from './AddError';

export const REQUESTED_LEAD = 'REQUESTED_LEAD';
export const RECEIVED_LEAD = 'RECEIVED_LEAD';
export const REQUEST_LEAD_FAILED = 'REQUEST_LEAD_FAILED';

const viewLead = (id, isDirect = false) => (
  (dispatch) => {
    if (isDirect === false && window === window.parent && window.showInlineLead !== undefined) {
      window.showInlineLead(`/leads/${id}`);
      return Promise.resolve();
    }

    dispatch({
      type: REQUESTED_LEAD,
    });

    return axios.get(`/api/leads/${id}`).then((response) => {
      dispatch({
        type: RECEIVED_LEAD,
        data: response.data.data,
        path: window.location.pathname,
      });
      if (isDirect === false) {
        history.push(`/leads/${id}`);
      }
      setTimeout(() => {
        if (window !== window.parent) {
          window.document.documentElement.style.display = null;
        }
      }, 100);
    }).catch((error) => {
      dispatch({
        type: REQUEST_LEAD_FAILED,
      });
      store.dispatch(addError({
        text: 'Could not load lead',
        originalError: error,
      }));
    });
  }
);

export default viewLead;
